import isFunction from 'lodash/isFunction';
import React from 'react';

/**
 * `props` are defined through 'noRowsOverlayParams' props to GridPanel component.
 */
export const GridNoDataOverlay = ({
	EmptyGridView,
	noDataOverlayText = false,
	...rest
}) => {
	const noDataText = noDataOverlayText ? '' : 'No Data.';
	return (
		<div className="ag-overlay-loading-center">
			{isFunction(EmptyGridView) ? <EmptyGridView {...rest} /> : noDataText}
		</div>
	);
};
